import { Button } from 'antd';

function StickyDrawerFooter({ onClick }) {
  return (
    <div className="drawer-sticky-footer gx-d-flex gx-align-items-center gx-justify-content-between ">
      Yazar önerilerde görünmüyorsa buradan ekleyebilirsiniz.
      <Button
        className="gx-mb-0 "
        type="primary"
        htmlType="button"
        onClick={onClick}
      >
        Yazar Ekle
      </Button>
    </div>
  );
}

export default StickyDrawerFooter;
